var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "vat-switcher",
      on: {
        mouseenter: function($event) {
          _vm.hover = true
        },
        mouseleave: function($event) {
          _vm.hover = false
        }
      }
    },
    [
      _c("tg-form-switch", {
        attrs: {
          id: "vat_switch",
          label: _vm.$t("text.price.with_vat"),
          description: true
        },
        on: {
          input: _vm.update,
          mouseover: function($event) {
            _vm.hover = true
          }
        },
        model: {
          value: _vm.enabled,
          callback: function($$v) {
            _vm.enabled = $$v
          },
          expression: "enabled"
        }
      }),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.enabled && _vm.hover
          ? _c("div", { staticClass: "vat-switcher__description" }, [
              _c("div", { staticClass: "vat-switcher__text" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("text.price.excl_question")) +
                    "\n      "
                )
              ]),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "vat-switcher__action",
                  attrs: { href: "#" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      _vm.enabled = false
                    }
                  }
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("text.price.excl_answer")) +
                      "\n      "
                  )
                ]
              )
            ])
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }